

import { HttpErrorResponse } from '@angular/common/http';
import { createFeatureSelector } from '@ngrx/store';
import { IAuthUser } from 'FoxxyInterfaces';

export interface UserState  {
  actualUser: { [key: string]: any };
  authuser: IAuthUser;
  error: Error | HttpErrorResponse;
}


export interface AppState   {
  userstate: UserState;
}

export const InitialUserState: UserState = {
  actualUser: {},
  authuser: null,
  error: null
};


export const userfeatureName = 'user';

export const selectNotificationsState = createFeatureSelector<AppState>(userfeatureName);



